

























import {Vue, Component, Prop} from 'vue-property-decorator';
import BottomNav from '@/pro/components/BottomNav.vue';
import PopupContainer from '@/pro/components/popup/Container.vue';
@Component({
  components: {BottomNav, PopupContainer}
})
export default class PageLayout extends Vue {
  @Prop({ required: true })
  private readonly title: string;
}
